import * as yup from 'yup';
import { i18n } from '@shared/i18n';
import StringArrayField from '@shared/fields/string-array-field';

export default class EmailsField extends StringArrayField {
  forFormRules() {
    const emailsValidator = yup
      .array()
      .label(this.label)
      .of(
        yup
          .string()
          .email(i18n('user.validations.email'))
          .label(i18n('user.fields.email'))
          .max(255)
          .required(),
      );

    const output = [{
      validator: (rule, value, callback) => {
        try {
          if (!value) return callback();
          emailsValidator.validateSync(value);
          callback();
        } catch (error) {
          callback(error);
        }
      },
      trigger: 'blur'
    }];

    if (this.required) {
      output.push({
        required: !!this.required,
        message: i18n('validation.mixed.required').replace(
          '${path}',
          this.label,
        )
      });
    }

    return output;
  }
}
